export enum DBA {
  JS = 0,
  XO = 1
}
